'use strict'

module.exports = function hex2rgb (hex) {
  return {
    // skip # at position 0
    r: parseInt(hex.slice(1, 3), 16) / 255,
    g: parseInt(hex.slice(3, 5), 16) / 255,
    b: parseInt(hex.slice(5, 7), 16) / 255
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/scale-color-perceptual/utils/hex2rgb.js
// module id = 852
// module chunks = 0